import { gql } from '@apollo/client';

export const FILES = gql`
  fragment fileFields on File {
    id
    path
    name
    creator {
      id
      name
    }
    parentId
    createdAt
    size
    mimeType
    metadata {
      licenseName
    }
  }
`;

export const FOLDERS = gql`
  fragment folderFields on Folder {
    id
    name
    path
    parentId
    creator {
      id
      name
    }
    createdAt
    files {
      ...fileFields
    }
  }
`;

export const GET_PERSONAL_DRIVE = gql`
  ${FILES}
  ${FOLDERS}
  query getPersonalDrive {
    currentUser {
      id
      tier {
        name
        slotsRemaining
      }
      drive {
        id
        info {
          total
          used
          remaining
        }
        nodeByPath {
          id
          path
          name
          createdAt
          ... on Folder {
            ...folderFields
            folders {
              ...folderFields
              folders {
                ...folderFields
                folders {
                  ...folderFields
                  folders {
                    ...folderFields
                    folders {
                      ...folderFields
                      folders {
                        ...folderFields
                      }
                    }
                  }
                }
              }
            }
          }
          ... on File {
            ...fileFields
          }
        }
      }
    }
  }
`;

export const GET_USER_DRIVE = gql`
query getPersonalDrive($userId: ID!, $orgId: ID!) {
  userDrive(userId: $userId, orgId: $orgId) {
    id
    path
    name
    creator {
      id
      name
    }
    parentId
    createdAt
    size
    mimeType
    metadata {
      licenseName
    }
    signedUrl
  }
}
`;

export default GET_PERSONAL_DRIVE;
